"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var Utility_1 = require("../Utility");
var StyledTooltipContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  position: relative;\n  outline: none;\n"], ["\n  display: inline-block;\n  position: relative;\n  outline: none;\n"])));
var StyledToolTip = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  white-space: nowrap;\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  white-space: nowrap;\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (props) {
    return props.$position === 'top' &&
        "\n    left: 50%;\n    bottom: calc(100% + 7px);\n    transform: translateX(-50%);\n    &:after {\n      border-top: 5px solid var(--t2-color-tooltip-bg);\n      border-left: 6px solid transparent;\n      border-right: 6px solid transparent;\n      bottom: -5px;\n      left: 50%;\n      margin-left: -6px;\n    }\n\n  ";
}, function (props) {
    return props.$position === 'bottom' &&
        "\n    left: 50%;\n    top: calc(100% + 7px);\n    transform: translateX(-50%);\n    &:after {\n      border-bottom: 5px solid var(--t2-color-tooltip-bg);\n      border-left: 6px solid transparent;\n      border-right: 6px solid transparent;\n      top: -5px;\n      left: 50%;\n      margin-left: -6px;\n    }\n  ";
}, function (props) {
    return props.$position === 'left' &&
        "\n    top: 50%;\n    right: calc(100% + 7px);\n    transform: translateY(-50%);\n    &:after {\n      border-left: 5px solid var(--t2-color-tooltip-bg);\n      border-top: 6px solid transparent;\n      border-bottom: 6px solid transparent;\n      top: 50%;\n      right: -5px;\n      margin-top: -6px;\n    }    \n  ";
}, function (props) {
    return props.$position === 'right' &&
        "\n    top: 50%;\n    left: calc(100% + 7px);\n    transform: translateY(-50%);\n    &:after {\n      border-right: 5px solid var(--t2-color-tooltip-bg);\n      border-top: 6px solid transparent;\n      border-bottom: 6px solid transparent;\n      top: 50%;\n      left: -5px;\n      margin-top: -6px;\n    }     \n  ";
});
var Tooltip = function (props) {
    var _a = (0, Utility_1.handleUtility)(props), tooltip = _a.tooltip, children = _a.children, className = _a.className, forceOpen = _a.forceOpen, _b = _a.position, position = _b === void 0 ? 'top' : _b, _c = _a.tabIndex, tabIndex = _c === void 0 ? 0 : _c;
    var _d = (0, react_1.useState)(forceOpen), show = _d[0], setShow = _d[1];
    react_1.default.useEffect(function () {
        setShow(forceOpen);
    }, [forceOpen]);
    return (react_1.default.createElement(StyledTooltipContainer, { className: (0, classnames_1.default)('t2-tooltiped-container', className), onBlur: function () { return setShow(forceOpen); }, onFocus: function () { return setShow(true); }, onMouseEnter: function () { return setShow(true); }, onMouseLeave: function () { return setShow(forceOpen); }, role: 'tooltip', tabIndex: tabIndex },
        react_1.default.createElement(react_1.default.Fragment, null,
            show ? (react_1.default.createElement(StyledToolTip, { "$position": position, className: (0, classnames_1.default)('t2-tooltip', "t2-place-".concat(position)) }, tooltip)) : null,
            children)));
};
exports.default = Tooltip;
var templateObject_1, templateObject_2;
